import React, { act, useEffect, useState } from 'react';
import 'bootstrap-select';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'component/LoadingSpinner';
import GoodsService from 'service/GoodsService';
import { GoodsCreateReq } from 'domain/payload/request/goods/GoodsCreateReq';
import { GoodsUpdateReq } from 'domain/payload/request/goods/GoodsUpdateReq';

const GoodsForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const navigate = useNavigate();

  const goodsService = GoodsService();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [dimension, setDimension] = useState('');
  const [weight, setWeight] = useState(0);
  const [formInstructionId, setFormInstructionId] = useState(null);

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setIsLoadingSave(true)
    try {
      if (id == "0") {
        await goodsCreate()
        alert(`Data ${name} successfully created!`)
        navigate("/goods")
      } else {
        await goodsUpdate()
        alert(`Data ${name} successfully updated!`)
        navigate("/goods")
      }
      setIsLoadingSave(false)
    } catch (e) {
      alert(e)
      setIsLoadingSave(false)
    }
  };

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) return;

    setIsLoadingDetail(true)
    try {
      const res = await goodsService.goodsDetail(token, id ?? "0");
      console.log(res)
      setName(res.data?.name!)
      setDescription(res.data?.description!)
      setDimension(res.data?.dimension!)
      setWeight(res.data?.weight!)
      setFormInstructionId(null)

      setIsLoadingDetail(false)
    } catch (err) {
      console.error(err);
      setIsLoadingDetail(false)
    }
  };

  const goodsCreate = async () => {
    const token = profile?.data.token;
    if (!token) return;

    try {
      var request: GoodsCreateReq = {
        name: name,
        description: description,
        dimension: dimension,
        weight: weight,
        tagId: ""
      }

      await goodsService.goodsCreate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  const goodsUpdate = async () => {
    const token = profile?.data.token;
    if (!token) return;

    try {
      var request: GoodsUpdateReq = {
        id: id!,
        name: name,
        description: description,
        dimension: dimension,
        weight: weight,
        tagId: ""
      }

      await goodsService.goodsUpdate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  useEffect(() => {
    if (id != "0") {
      fetchDetail()
    }
  }, [])

  return (
    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">{id == "0" ? "Add Goods" : "Edit Goods"}</h4>
        <div className="p-4" style={{ background: 'white' }}>

          {
            isLoadingDetail ?
              <LoadingSpinner />
              :
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div>
                      <h5 className="mb-4">Basic Information</h5>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Name</label>
                        <input
                          type="text"
                          id="name"
                          className="form-control form-control-compact"
                          value={name}
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="description" className="form-label fw-semibold">Description</label>
                        <input
                          type="text"
                          id="description"
                          className="form-control form-control-compact"
                          value={description}
                          placeholder="Description"
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div>
                      <h5 className="mb-4">Dimensions</h5>
                      <div className="mb-3">
                        <label htmlFor="dimension" className="form-label fw-semibold">Dimension</label>
                        <input
                          type="text"
                          id="dimension"
                          className="form-control form-control-compact"
                          value={dimension}
                          placeholder="Length x Width x Height"
                          onChange={(e) => setDimension(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="weight" className="form-label fw-semibold">Dimension</label>
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          id="weight"
                          className="form-control form-control-compact"
                          value={weight}
                          placeholder="weight"
                          onChange={(e) => setWeight(Number(e.target.value))}
                          required
                        />
                        <span> Gram</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-sm-6">
                  <div>
                    <h5 className="mb-4">Form Instructions</h5>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label fw-semibold">Name</label>
                      <input
                        type="text"
                        id="name"
                        className="form-control form-control-compact"
                        value={name}
                        placeholder="Name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="description" className="form-label fw-semibold">Description</label>
                      <input
                        type="text"
                        id="description"
                        className="form-control form-control-compact"
                        value={description}
                        placeholder="Description"
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div> */}

                <div className="w-100 d-flex justify-content-end">
                  <Link to="/goods">
                    <button className="btn btn-outline-primary">Cancel</button>
                  </Link>
                  <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center ms-2" disabled={isLoadingSave}>
                    {
                      isLoadingSave &&
                      <>
                        <LoadingSpinner reverse={true} />
                        <p className="ms-2"></p>
                      </>
                    }
                    Save
                  </button>
                </div>
              </form>
          }
        </div>
      </div>
    </div>
  );

};

export default GoodsForm;